import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";
import VenueSection from "../../components/VenueSection/VenueSection";
import { ConfettiTypes } from "../../hooks/useConfetti";
import { ScrollerContext } from "../../components/RoyalMahal/hooks";
import { UTSAV_THEME } from "../../components/Utsav/theme.config";
import { UTSAV_FONTS } from "../../components/Utsav/fonts";
import Defs from "../../components/Utsav/art/Defs";
import GateScreen from "../../components/Utsav/scenes/GateScreen";
import Hero from "../../components/Utsav/scenes/Hero";
import Couple from "../../components/Utsav/scenes/Couple";
import CoupleFlight from "../../components/Utsav/scenes/CoupleFlight";
import CalendarSection from "../../components/Utsav/scenes/CalendarSection";
import Events from "../../components/Utsav/scenes/Events";
import Rsvp from "../../components/Utsav/scenes/Rsvp";
import Blessings from "../../components/Utsav/scenes/Blessings";
import Closing from "../../components/Utsav/scenes/Closing";
import ArchGarland from "../../components/Utsav/art/ArchGarland";
import PetalBurst from "../../components/Utsav/PetalBurst";
import "../../components/Utsav/styles/utsav.scss";


/**
 * The Utsav theme (its name and identifier live in components/Utsav/theme.config.js):
 * a haldi-mela invitation in bright Rajasthani colours, with umbrellas, peacocks,
 * dholaks, shehnais, latkans and marigold torans. Same information and order as
 * the other themes; see components/Utsav. It opens at a painted haveli gate dressed in
 * marigolds (scenes/GateScreen.js); once its doors open, the first page plays. Scrolling on,
 * the couple's illustration flies from the courtyard to the couple page (CoupleFlight).
 * Tapping anywhere showers petals (PetalBurst).
 */
const Utsav = ({ isInviteOpen, onOpenInvite }) => {
  const scrollerRef = useRef(null);
  const [revealed, setRevealed] = useState(isInviteOpen);
  const [gateGone, setGateGone] = useState(isInviteOpen);

  const reveal = () => {
    scrollerRef.current?.scrollTo(0, 0);
    setRevealed(true);
    onOpenInvite?.();
  };

  return (
    <ScrollerContext.Provider value={scrollerRef}>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="stylesheet" href={UTSAV_FONTS} />
      </Helmet>
      <div ref={scrollerRef} className={`utsav ${revealed ? "is-revealed" : "is-gated"}`} data-theme={UTSAV_THEME.identifier}>
        <Defs />
        {!gateGone && <GateScreen onReveal={reveal} onDone={() => setGateGone(true)} />}
        <Hero revealed={revealed} />
        <Couple />
        {revealed && <CoupleFlight />}
        <CalendarSection />
        <Events />
        <LetterEnvelope confettiType={ConfettiTypes.marigoldPetals} />
        <VenueSection
          variant="plain"
          revealSection={false}
          archDecoration={<ArchGarland className="ut-venue-garland" radius={300} seed={51} />}
        />
        <Rsvp />
        <Blessings />
        <Closing />
        <Footer footerClass="ut-footer" />
        <Scrollbar />
        <PetalBurst />
      </div>
    </ScrollerContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  isInviteOpen: state.inviteDetails?.isOpen || false,
});

export default connect(mapStateToProps)(Utsav);
